module.exports = __webpack_public_path__ + "media/images/admin2/AdminSpotsShow__video-6be52dc716171f58d34ef763fa10b972.svg";